// PROD-CUSTO-RLS Ato 1 (I.164): regra única de quem vê custo e margem na tela — master ou a chave de preços
// (products:manage_prices), a mesma do painel do produto (ProductDetailsSheet) e do assistente de grade. É ocultação de
// tela, não proteção: o banco ainda entrega o custo até o Ato 2.
import { usePermissions } from '@/hooks/usePermissions';

export const useCanSeeCost = (): boolean => {
  const { isMaster, canAccess } = usePermissions();
  return isMaster || canAccess('products:manage_prices');
};
